export const getPhoneNumberDisplay = (phoneNumber) => {
  if(phoneNumber) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`
  }
  return '';
}